import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../../components/SEO';
import { PageHero, Icon, Button } from '../../components/ui';

const slugify = (s = '') => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

const TermsAndConditions = () => {
  const { t } = useTranslation();


  const sections = [
    {
      title: t('1. Acceptance of Terms'),
      content: t('By registering for an account on AyodhyaDham.info, you agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our services.')
    },
    {
      title: t('2. User Registration'),
      content: t('To use certain features of the website, you must register for an account. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete.')
    },
    {
      title: t('3. User Conduct'),
      content: t('You agree not to use the website for any illegal or unauthorized purpose. You must not, in the use of the service, violate any laws in your jurisdiction.')
    },
    {
      title: t('4. Booking and Reservations'),
      content: t('All hotel and temple visit bookings are subject to availability and confirmation. We reserve the right to refuse any booking without giving reasons. We act as a booking agent for third-party service providers and are not responsible for the quality of their services.')
    },
    {
      title: t('5. Payment and Cancellation'),
      content: t('Payment terms and cancellation policies vary by service provider. Please review the specific terms before making a booking. Refunds, if applicable, will be processed according to the service provider\'s policies.')
    },
    {
      title: t('6. Privacy Policy'),
      content: t('Your use of the website is also governed by our Privacy Policy, which is incorporated into these Terms by reference.')
    },
    {
      title: t('7. Limitation of Liability'),
      content: t('AyodhyaDham.info shall not be liable for any direct, indirect, incidental, special, consequential, or exemplary damages resulting from your use or inability to use the service.')
    },
    {
      title: t('8. Changes to Terms'),
      content: t('We reserve the right to modify these terms at any time. We will provide notice of significant changes by posting a prominent notice on our website.')
    },
    {
      title: t('9. Governing Law'),
      content: t('These Terms shall be governed by the laws of India, without regard to its conflict of law provisions.')
    },
    {
      title: t('10. Contact Information'),
      content: t('If you have any questions about these Terms, please contact us at support@ayodhyadham.info.')
    }
  ];

  return (
    <>
      <SEO
        title="Terms & Conditions"
        description="Terms and conditions for using AyodhyaDham.info — bookings, accounts, content and liability."
        canonicalUrl="/terms"
      />
      <PageHero
        compact
        crumbs={[{ label: t('Home'), to: '/' }, { label: t('Terms & Conditions') }]}
        title={t('Terms & Conditions')}
        subtitle={t('The agreement between you and AyodhyaDham.info')}
      />

      <div className="container content-wrap">
        <div className="legal">
          <nav className="legal__nav" aria-label={t('On this page')}>
            {sections.map((s) => (
              <a key={s.title} href={`#${slugify(s.title)}`}>{s.title}</a>
            ))}
          </nav>

          <div className="content">
            <p className="legal__updated">
              <Icon name="file-text" size={15} style={{ verticalAlign: 'text-bottom', marginRight: 6, color: 'var(--primary)' }} />
              {t('Last updated')}: {t('6 September 2026')}
            </p>

            <div className="prose">
              {sections.map((s) => (
                <section key={s.title} id={slugify(s.title)}>
                  <h2>{s.title}</h2>
                  <p>{s.content}</p>
                </section>
              ))}
            </div>

            <div className="card card--pad" style={{ marginTop: 32, background: 'var(--surface-2)' }}>
              <h3 className="h-card" style={{ marginBottom: 8 }}>{t('Questions about this page?')}</h3>
              <p className="small muted" style={{ marginBottom: 14 }}>{t('Write to us and our team will get back to you.')}</p>
              <Button size="sm" variant="outline" to="/contact" icon={<Icon name="arrow-right" size={14} />}>{t('Contact Us')}</Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditions;
